export default defineNuxtRouteMiddleware(() => {
  const nuxtApp = useNuxtApp()
  if (process.server || (nuxtApp.isHydrating && nuxtApp.payload.serverRendered))
    return

  useRootStore().clearEarlyBirdRecords()
})
